<template>
  <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="blue darken-3" dark>
    <v-progress-linear
      :active="isAppLoading"
      :indeterminate="true"
      absolute
      :top="true"
      color="deep-orange darken-1"
    ></v-progress-linear>

    <v-toolbar-title style="max-width: 300px">
      <!-- <v-app-bar-nav-icon @click.stop="toggleDrawer" /> -->
      <span>Nexus</span>
    </v-toolbar-title>
    <v-spacer />

  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    drawer: null
  }),
  computed: {
    ...mapGetters([
      "isLoggedIn",
      "currentUser",
      "isAppLoading"
    ]),
  },
  methods: {
    ...mapActions(["toggleDrawer", "hideDrawer"]),
    logout() {
      this.$axios.post("gaa-user/signout").then(() => {
        this.$store.commit("logout");
        localStorage.removeItem("token");
        delete this.$axios.defaults.headers.common["Authorization"];
        this.$router.push({name: "Login"});
      });
    }
  }
};
</script>

<style>
</style>